import { Injectable }             from '@angular/core';
import { Http, Response }         from '@angular/http';
import { Observable }             from 'rxjs/Observable';
import { ConfigService }          from '../configuracion/config.service';
import { RequestBaseService }     from '../request-base/request-base.service';
import { JwtHttp, AuthService }   from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class ProyectoService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
    ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'proyecto'].join('/');
  }

  public consultarPorOrganizacion(id_org) {
    return this.http
    .get([this.ApiUrl,'organizacion',id_org].join('/'))
    .map(res => res.json());
  }

  public consultarProyectos(agrupados : boolean) {
    return this.http
    .get([this.ApiUrl,'agrupados', agrupados].join('/'))
    .map(res => res.json());
  }



}



// WEBPACK FOOTER //
// ./src/app/services/proyecto/proyecto.service.ts